var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhillipinesFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5118_29970)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5118_29970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-18 0H78V24L-3.06667 47.4667L-18 0Z",
    fill: "#0038A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.06667 24H78V48H-18L-3.06667 24Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5691 24L-18 48V0L23.5691 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.06719 28.7992C-0.41622 28.7992 1.73281 26.6502 1.73281 23.9992C1.73281 21.3483 -0.41622 19.1992 -3.06719 19.1992C-5.71815 19.1992 -7.86719 21.3483 -7.86719 23.9992C-7.86719 26.6502 -5.71815 28.7992 -3.06719 28.7992Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.06693 24L5.41787 22.3125L5.92241 22.8165L-3.06693 24ZM-3.06693 24L6.44294 23.3765L7.06641 24L6.44294 24.6234L-3.06693 24ZM-3.06693 24L5.92241 25.1834L5.41787 25.6874L-3.06693 24Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.06783 23.9992L1.73861 16.8063L2.45175 16.8059L-3.06783 23.9992ZM-3.06783 23.9992L3.2158 16.8338L4.09752 16.8338L4.09752 17.7156L-3.06783 23.9992ZM-3.06783 23.9992L4.12542 18.4796L4.12505 19.1928L-3.06783 23.9992Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.06755 24.0005L4.12533 28.807L4.1257 29.5201L-3.06755 24.0005ZM-3.06755 24.0005L4.0978 30.2842L4.0978 31.1659L3.21608 31.1659L-3.06755 24.0005ZM-3.06755 24.0005L2.45203 31.1938L1.73889 31.1934L-3.06755 24.0005Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7693 24.0008L16.9656 24.628L16.9266 26.5368L15.773 25.0152L13.9453 25.5683L15.036 24.0008L13.9453 22.4334L15.773 22.9864L16.9266 21.4648L16.9656 23.3736L18.7693 24.0008Z",
    fill: "#FCD116"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5118_29970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5118_29970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 48,
    fill: "white",
    transform: "translate(-18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhillipinesFlag);
export default __webpack_public_path__ + "static/media/phillipines-flag.21c75bf5f5b36c8c61e2b5d05e14c0f9.svg";
export { ForwardRef as ReactComponent };